const state = {
  title: '',
  items: [],
  total: 0
}

const getters = {
  getTitle: state => state.title,
  getItems: state => state.items,
  getListItems: state => {
    const items = []
    state.items.forEach(item => {
      if (item.children) {
        item.children.forEach(child => {
          items.push({
            guid: child.guid,
            text: child.text
          })

          if (child.children) {
            child.children.forEach(subitem => {
              items.push({
                guid: subitem.guid,
                text: subitem.text
              })
            })
          }
        })
      }
    })

    return items
  },
  getTotal: state => state.total
}

const mutations = {
  UPDATE_TITLE: (state, string) => {
    state.title = string
  },
  UPDATE_ITEMS: (state, items) => {
    state.items = [ ...items ]
  },
  UPDATE_TOTAL: (state, string) => {
    state.total = string
  }
}

const actions = {
  updateTitle: ({ commit }, title) => {
    commit('UPDATE_TITLE', title)
  },
  updateItems: ({ commit }, items) => {
    commit('UPDATE_ITEMS', items)
  },
  updateTotal: ({ commit, dispatch }, total) => {
    commit('UPDATE_TOTAL', total)
  }
}

export default {
  state,
  getters,
  mutations,
  actions,
  namespaced: true
}
